<script lang="ts" setup>
const props = defineProps({
  longPressDelay: {
    type: Number,
    default: 200,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits([
  "click",
  "dblclick",
  "longPress",
  "releaseLongPress",
]);

const timeout = ref<NodeJS.Timeout | undefined>();

const isLongPress = ref(false);
const longPressTimer = ref<NodeJS.Timeout | undefined>();

const onClick = (ev: MouseEvent) => {
  if (props.disabled) return;

  stopListening();

  if (isLongPress.value == true) {
    isLongPress.value = false;
    return;
  }

  if (timeout.value) {
    clearTimeout(timeout.value);
  }

  timeout.value = setTimeout(() => {
    emit("click");
  }, 300);
};

// Hmm ok todo here.
const onDoubleClick = async (ev: any) => {
  if (props.disabled) return;
  stopListening();

  if (timeout.value) {
    clearTimeout(timeout.value);
  }

  emit("dblclick", ev);
};

const stopListening = () => {
  cancelLongPressTimer();
  document.removeEventListener("mouseup", onMouseUpInternal);
  document.removeEventListener("touchend", onTouchEnd);
};

const startLongPressTimer = (ev: MouseEvent | TouchEvent) => {
  if (props.disabled) return;

  // reset state and clear any previous timers
  isLongPress.value = false;
  if (longPressTimer.value) clearTimeout(longPressTimer.value);

  longPressTimer.value = setTimeout(() => {
    // when timer elapses, emit longPress and begin listening for release
    isLongPress.value = true;
    // Cast to MouseEvent for consumers; TouchEvent also acceptable as any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    emit("longPress", ev as any);
  }, props.longPressDelay);
};

const cancelLongPressTimer = () => {
  if (longPressTimer.value) {
    clearTimeout(longPressTimer.value);
    longPressTimer.value = undefined;
  }
};

const onMouseDownInternal = (ev: MouseEvent) => {
  startLongPressTimer(ev);
  // listen for release to either cancel timer or emit release
  document.addEventListener("mouseup", onMouseUpInternal);
};

const onMouseUpInternal = (ev: MouseEvent) => {
  // if long press hasn't fired yet, cancel the timer so click/dblclick can proceed
  if (!isLongPress.value) {
    cancelLongPressTimer();
  } else {
    // long press had fired; emit release here and cleanup
    emit("releaseLongPress", ev);
  }
  document.removeEventListener("mouseup", onMouseUpInternal);
};

const onTouchStart = (ev: TouchEvent) => {
  startLongPressTimer(ev);
  document.addEventListener("touchend", onTouchEnd, { passive: true });
};

const onTouchEnd = (ev: TouchEvent) => {
  if (!isLongPress.value) {
    cancelLongPressTimer();
    // Let native click (tap) and dblclick handling proceed through existing handlers
  } else {
    emit("releaseLongPress", ev);
  }
  document.removeEventListener("touchend", onTouchEnd);
};
</script>

<template>
  <span
    @click="onClick"
    @dblclick="onDoubleClick"
    @mousedown="onMouseDownInternal"
    @touchstart.passive="onTouchStart"
  >
    <slot />
  </span>
</template>

<style scoped></style>
